import React from 'react';
import Dictionary from '../../../model/Dictionary';
import './CalendarLegendStyles.css';

const CalendarLegend = () => (
  <div className='calendar-legend'>
    <div className='item title'>
      <label>{Dictionary.flights.calendarLegend}</label>
    </div>
    <div className='item half'>
      <div className='calendar marker available' />
      <label>{Dictionary.flights.available}</label>
    </div>
    <div className='item half'>
      <div className='calendar marker full' />
      <label>{Dictionary.flights.flightFull}</label>
    </div>
    <div className='item'>
      <div className='calendar marker offline' />
      <label>{Dictionary.flights.offlineReservation}</label>
    </div>
    <div className='item'>
      <div className='calendar marker high-demand' />
      <label>{Dictionary.flights.highDemand}</label>
    </div>
  </div>
);

export default CalendarLegend;



// WEBPACK FOOTER //
// ./src/components/flights/calendarLegend/CalendarLegend.js